'use client';

import React from 'react';

export default function CTASection() {
  return (
    <section
      id="contact"
      className="relative py-24 sm:py-32 overflow-hidden"
      style={{ background: 'linear-gradient(rgb(5, 5, 5), rgb(6, 10, 20), rgb(5, 5, 5))' }}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="reveal cta-glow glass-card gradient-border-card rounded-3xl p-12 sm:p-16 lg:p-20 text-center relative overflow-hidden">
          {/* Background orbs */}
          <div className="absolute inset-0 pointer-events-none">
            <div
              className="float-orb absolute"
              style={{ top: '-20%', left: '50%', transform: 'translateX(-50%)', width: 500, height: 300, borderRadius: '50%', background: 'radial-gradient(circle, rgba(59, 130, 246, 0.12) 0%, transparent 70%)', filter: 'blur(40px)' }}
            />
            <div
              className="float-orb-alt absolute"
              style={{ bottom: '-20%', right: '20%', width: 300, height: 300, borderRadius: '50%', background: 'radial-gradient(circle, rgba(157, 76, 221, 0.1) 0%, transparent 70%)', filter: 'blur(40px)' }}
            />
          </div>

          <div className="relative z-10">
            {/* Icon */}
            <div
              className="inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-8 mx-auto"
              style={{ background: 'rgba(59, 130, 246, 0.1)', border: '1px solid rgba(59, 130, 246, 0.25)', color: 'rgb(59, 130, 246)', boxShadow: 'rgba(59, 130, 246, 0.2) 0px 0px 30px' }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M8 2v4" />
                <path d="M16 2v4" />
                <rect width="18" height="18" x="3" y="4" rx="2" />
                <path d="M3 10h18" />
                <path d="m9 16 2 2 4-4" />
              </svg>
            </div>

            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-blue-400 mb-5 block">Let&apos;s Work Together</span>

            <h2 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-white tracking-tight mb-6" style={{ letterSpacing: '-0.02em' }}>
              Ready to Scale <span className="gradient-text">with AI?</span>
            </h2>

            <p className="text-base sm:text-lg text-neutral-400 max-w-xl mx-auto mb-10 leading-relaxed">
              Let&apos;s turn your content into a growth machine. Book a free strategy call and let&apos;s map out your AI-powered growth plan.
            </p>

            {/* Perks */}
            <div className="flex flex-wrap items-center justify-center gap-6 mb-10 text-sm text-neutral-500">
              {[
                'Free 30-min strategy call',
                'No commitment required',
                'Custom growth plan included',
              ]?.map((perk) => (
                <div key={perk} className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-green-500" style={{ boxShadow: 'rgba(34, 197, 94, 0.6) 0px 0px 6px' }} />
                  {perk}
                </div>
              ))}
            </div>

            {/* CTA Button */}
            <a
              href="https://calendly.com/creatormaska/30min"
              target="_blank"
              rel="noopener noreferrer"
              className="glow-button inline-flex items-center gap-3 px-9 py-4 rounded-full text-base font-bold text-white"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M8 2v4" />
                <path d="M16 2v4" />
                <rect width="18" height="18" x="3" y="4" rx="2" />
                <path d="M3 10h18" />
                <path d="m9 16 2 2 4-4" />
              </svg>
              Book Your Free Call
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
